// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
import type {
  TPublishProjectRequest,
  TPublishProjectModel,
  IMappers,
  TPublishProjectResponse,
  TPublishProjectResponse_1,
  TPublishProjectResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';

export const defaultConfig: TPublishProjectModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'promotions-flow-control',
  pathApi: '/v1/publish-project/',
  requestType: 'json',
  interserviceAuthEnabled: true,
} as TPublishProjectModel;

export function createPublishProjectModel(parameters: TPublishProjectRequest): TPublishProjectModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IPublishProjectOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TPublishProjectRequest;
}

export async function fetchPublishProject<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublishProjectOptions<TResponse200, TResponse400>): Promise<TPublishProjectResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createPublishProjectModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TPublishProjectResponse_1);
    }
    if (statusCode === 400) {
      return mappers[400](response as TPublishProjectResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TPublishProjectResponse;
}
